export enum LabelType {
    HandlingUnit = 1,
    Slot = 2,
    Item = 3,
    ShippingLabel = 4,
    Zone = 5,
    PackingSlip = 6,
}
